export default __webpack_public_path__ + "static/media/naginlake.866cf5cd.jpg";